import { ImageCell } from '@/components/shared/ImageCell';
import type { AttractionTheme } from '@/config/objects/attraction-themes';

interface AttractionThemeImageCellProps {
  attractionTheme?: AttractionTheme;
  size?: 'sm' | 'lg';
}

/**
 * Editable attraction theme image cell component with upload and delete actions
 */
export function AttractionThemeImageCell({ attractionTheme, size = 'sm' }: AttractionThemeImageCellProps) {
  if (!attractionTheme?.attractionId) return null;

  return (
    <ImageCell
      item={attractionTheme}
      endpoint={`/attractions/${attractionTheme.attractionId}/themes`}
      entityName="Attraction Theme"
      imageLabel="Theme Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
